import React from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import styled from "styled-components";

const Container = styled(CircularProgressbar)`
  .CircularProgressbar-trail {
    stroke: #eff0f5 !important;
  }

  .CircularProgressbar-text {
    fill: white !important;
    font-size: 24px !important;
  }
`;

function GradientSVG({ startColor, endColor, idCSS, rotation }: any) {
  let gradientTransform = `rotate(${rotation})`;
  return (
    <svg style={{ height: 0 }}>
      <defs>
        <linearGradient id={"gradient"} gradientTransform={gradientTransform}>
          <stop offset="0%" stopColor={startColor} />
          <stop offset="100%" stopColor={endColor} />
        </linearGradient>
      </defs>
    </svg>
  );
}
function CircularProgress({
  value,
  maxValue,
  color,
}: {
  value: number;
  maxValue: number;
  color?: string;
}) {
  return (
    <>
      <Container
        value={maxValue - value}
        maxValue={maxValue}
        text={`${value}`}
      />
      {/* {"FF5757"} */}
      <GradientSVG
        startColor={color ?? "#FFEFD6"}
        endColor={color ?? "#D7B98B"}
        rotation="0"
      />
    </>
  );
}

export default CircularProgress;
